export type WalletAddress = `0x${string}`;

const ADDRESS_PATTERN = /^0x[0-9a-fA-F]{40}$/;

export function normalizeWalletAddress(address: string): WalletAddress {
    const trimmed = address.trim();
    if (!ADDRESS_PATTERN.test(trimmed)) {
        throw new TypeError("Wallet address must be a 20-byte EVM address");
    }
    return trimmed.toLowerCase() as WalletAddress;
}

export function shortenWalletAddress(address: WalletAddress): string {
    return `${address.slice(0, 6)}…${address.slice(-4)}`;
}

/**
 * Guests play without a wallet: the server makes each one an identity of its own, shaped like an address so rounds,
 * stats and names work the same, starting with "guest" in hex. Nobody holds a key for one, nobody can pick one (there
 * is no pasting an address any more), and every part of the platform can tell a guest apart by the address alone.
 */
export const GUEST_ADDRESS_PREFIX = "0x6775657374";

export function isGuestAddress(address: string): boolean {
    return address.toLowerCase().startsWith(GUEST_ADDRESS_PREFIX);
}

/** a guest's name, from its address: the same guest is always the same Guest-1234 */
export function guestName(address: string): string {
    return `Guest-${1000 + (Number.parseInt(address.slice(-6), 16) % 9000)}`;
}

export interface WalletSession {
    readonly id: string
    readonly address: WalletAddress
    /** the owner signed in with the wallet itself (a signature): every room, payouts, a chosen name */
    readonly verified: boolean
    /** a guest (no wallet): the free room and the Training Range, named Guest-1234, kept off the leaderboards */
    readonly guest?: boolean
    readonly termsVersion: string
    readonly issuedAt: number
    readonly expiresAt: number
}
